import { SelectCompanyModalComponent } from "./components/select-company-modal/select-company-modal.component";
import { ConfigService } from "src/app/services/config.service";
import { SignalRService } from "./services/signalr.service";
import { NewsComponent } from "./components/news/news.component";
import { BrowserModule } from "@angular/platform-browser";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
  NgModule,
} from "@angular/core";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";

import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha";
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./screens/home/home.component";
import { LoginComponent } from "./screens/login/login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SearchPipe } from "./screens/home/search.pipe";
import { TradesComponent } from "./components/trades/trades.component";
import { MarketDepthComponent } from "./components/market-depth/market-depth.component";
import { NewsDetailsModalComponent } from "./components/news-details-modal/news-details-modal.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MarketWatchTableComponent } from "./components/market-watch-table/market-watch-table.component";
import { MatDialogModule } from "@angular/material/dialog";
import { NewTradeChartComponent } from "./components/new-trade-chart/new-trade-chart.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { GridsterModule } from "angular-gridster2";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MarketDepthAsksComponent } from "./components/market-depth-asks/market-depth-asks.component";
import { MarketDepthBidsComponent } from "./components/market-depth-bids/market-depth-bids.component";
import { DynamicModule } from "ng-dynamic-component";
import { MatCardModule } from "@angular/material/card";
import { MatTableModule } from "@angular/material/table";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ContextMenuModule } from "ngx-contextmenu";
import { CustomNumberPipe } from "./services/custom-number.pipe";
import { NgxMarqueeModule } from "ngx-marquee";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ContextMenuComponent } from "./components/market-watch-table/context-menu/context-menu.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MarketGridViewComponent } from "./components/market-grid-view/market-grid-view.component";
import { MarketTradesComponent } from "./components/market-trades/market-trades.component";
import { HomeMarketSummaryComponent } from "./components/home-market-summary/home-market-summary.component";
import { CompanyProfileComponent } from "./screens/company-profile/company-profile.component";
import { NavBarComponent } from "./components/nav-bar/nav-bar.component";
import { SignalRConfiguration, SignalRModule } from "ng2-signalr";
import { environment } from "src/environments/environment";
import { OrderBuyComponent } from "./components/order-buy/order-buy.component";
import { HomeNewComponent } from "./screens/home-new/home-new.component";
import { KtdGridModule } from "@katoid/angular-grid-layout";
import { HistoricalComponent } from "./components/historical/historical.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatTabsModule } from "@angular/material/tabs";
import { ExportAsModule } from "ngx-export-as";
import { ConfirmationComponent } from "./components/confirmation/confirmation.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { UpdateOrderComponent } from "./components/update-order/update-order.component";
import { GlobalMarketsComponent } from "./screens/global-markets/global-markets.component";
import { MarketNewsComponent } from "./components/market-news/market-news.component";

import { UserPortfolioComponent } from "./components/user-portfolio/user-portfolio.component";
import {
  NgbAccordionModule,
  NgbModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { MatRadioModule } from "@angular/material/radio";
import { CreateAlertComponent } from "./components/create-alert/create-alert.component";
import { AlertManagerComponent } from "./components/alert-manager/alert-manager.component";
import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import { UpdateFlashDirective } from "./components/market-watch-table/update-flash.directive";
import { CarouselModule } from "ngx-owl-carousel-o";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { LocalMarketComponent } from "./screens/local-market/local-market.component";
import { InvoiceComponent } from "./screens/user-profile/invoice/invoice.component";
import { InvoiceDetailsComponent } from "./screens/user-profile/invoice/invoice-details/invoice-details.component";
import { NgxPrintModule } from "ngx-print";
import { SelectStatementDateComponent } from "./components/select-statement-date/select-statement-date.component";
import { PreviewInvoiceComponent } from "./screens/user-profile/invoice/preview-invoice/preview-invoice.component";
import { NgxPrinterModule } from "ngx-printer";
import { StatementComponent } from "./screens/user-profile/statement/statement.component";
import { StatementDetailsComponent } from "./screens/user-profile/statement/statement-details/statement-details.component";
import { MaterialMarketWatchComponent } from "./components/material-market-watch/material-market-watch.component";
import { DataTablesModule } from "angular-datatables";
import { DetailedQuotaComponent } from "./screens/detailed-quota/detailed-quota.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { SlickMarketWatchComponent } from "./components/slick-market-watch/slick-market-watch.component";
import { AngularSlickgridModule } from "angular-slickgrid";
import { AccountHeaderComponent } from "./components/account-header/account-header.component";
import { MatSortModule } from "@angular/material/sort";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { QuotaBidsAsksComponent } from "./components/quota-bids-asks/quota-bids-asks.component";
import { QuotaTradeComponent } from "./components/quota-trade/quota-trade.component";
import { MarginCalculatorComponent } from "./components/margin-calculator/margin-calculator.component";
import { TradesHistoryComponent } from "./components/trades-history/trades-history.component";
import { TradesOrderHistoryComponent } from "./components/trades-order-history/trades-order-history.component";
import { OrderHistoryComponent } from "./components/order-history/order-history.component";
import { TwfaComponent } from "./components/twfa/twfa.component";
import { CheckArrayPipe } from "./pipes/check-array.pipe";
import { OrdinalPipe } from "./pipes/ordinal.pipe";
import { ForgetPasswordComponent } from "./components/forget-password/forget-password.component";
import { CreateUserComponent } from "./components/create-user/create-user.component";
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { RequestHeaderInterceptor } from "./services/request-header.interceptor";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { NgCircleProgressModule } from "ng-circle-progress";
import {
  MatMomentDateModule,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import { MatTooltipModule } from "@angular/material/tooltip";
import { VerifyEmailComponent } from "./components/verify-email/verify-email.component";
import { PasswordValidationSectionComponent } from "./components/password-validation-section/password-validation-section.component";
import { SettingsComponent } from "./components/settings-modal/settings.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { ConfirmationPopoverModule } from "angular-confirmation-popover";
import { ToastrModule } from "ngx-toastr";

// export function appInitializerFactory(injector: Injector) {
//   var appSessionService = injector.get(ConfigService);
//   feedUrl = appSessionService.getFeedUrl;
// }

import { UserIdleModule } from "angular-user-idle";
import { NotFullMarketComponent } from './components/not-full-market/not-full-market.component';
import { NgxLoadingModule } from "ngx-loading";
import { MillionPipe } from "./pipes/million.pipe";
import { AnimatedTextComponent } from "./components/animated-text/animated-text.component";
import { TradingViewChartComponent } from "./components/trading-view-chart/trading-view-chart.component";
import { SelectedOrderTradeComponent } from "./components/selected-order-trade/selected-order-trade.component";
import { UrlConstants } from "./models/urlConstants";
import { NewLoginComponent } from "./screens/new-login/new-login.component";
import { InvoicesModalComponent } from './components/invoices-modal/invoices-modal.component';
import { TechnicalReportsComponent } from './screens/technical-reports/technical-reports.component';
import { InfoModalComponent } from './components/info-Modal/info-modal.component';
import { IPOComponent } from './screens/ipo/ipo.component';
import { IpoSelectedSymbolComponent } from './components/ipo-selected-symbol/ipo-selected-symbol.component';
import { IpoSelectedSymbolTimlinePdfComponent } from './components/ipo-selected-symbol-timline-pdf/ipo-selected-symbol-timline-pdf.component';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { TestComponent } from './screens/test/test.component';
import { FavoriteMenuComponent } from './components/slick-market-watch/favorite-menu/favorite-menu.component';
import { MutualFundComponent } from './screens/mutual-fund/mutual-fund.component';
import { FundAccOrderModalComponent } from './components/fund-acc-order-modal/fund-acc-order-modal.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatStepperModule } from '@angular/material/stepper';
import { SelectedSymbolChartsComponent } from './components/selected-symbol-charts/selected-symbol-charts.component';
import { SelectedSymbolDetailsPdfsComponent } from './components/selected-symbol-details-pdfs/selected-symbol-details-pdfs.component';
import { SharedModule } from "./shared/shared.module";
import { IpoAccOrderModalComponent } from './components/ipo-acc-order-modal/ipo-acc-order-modal.component';
import { ReportingComponent } from './reports/reporting/reporting.component';
import { GenericReportComponent } from './reports/generic-report/generic-report.component';
import { DxReportViewerModule } from "devexpress-reporting-angular";
import { FundmentalReportComponent } from "./screens/fundmental-report/fundmental-report.component";
import { ReportsComponent } from "./screens/reports/reports.component";

var url;
export function initializeApp(appInitService: ConfigService) {
  return (): Promise<any> => {
    url = appInitService.getFeedUrl;
    return appInitService.Init();
  };
}

export function createConfig(): SignalRConfiguration {
  const c = new SignalRConfiguration();

  let key = UrlConstants.appKey;
  c.url = UrlConstants.feedUrl;

  c.logging = false;

  c.executeEventsInZone = true; // optional, default is true
  c.executeErrorsInZone = false; // optional, default is false
  c.executeStatusChangeInZone = true; // optional, default is true

  return c;
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    SearchPipe,
    TradesComponent,
    NewsComponent,
    MarketDepthComponent,
    NewsDetailsModalComponent,
    MarketWatchTableComponent,
    NewTradeChartComponent,
    MarketDepthAsksComponent,
    MarketDepthBidsComponent,
    CustomNumberPipe,
    ContextMenuComponent,
    MarketGridViewComponent,
    MarketTradesComponent,
    HomeMarketSummaryComponent,
    CompanyProfileComponent,
    NavBarComponent,
    OrderBuyComponent,
    HomeNewComponent,
    HistoricalComponent,
    ConfirmationComponent,
    UpdateOrderComponent,
    GlobalMarketsComponent,
    MarketNewsComponent,
    // UserPortfolioComponent,
    CreateAlertComponent,
    AlertManagerComponent,
    UpdateFlashDirective,
    LocalMarketComponent,
    InvoiceComponent,
    InvoiceDetailsComponent,
    StatementDetailsComponent,
    SelectStatementDateComponent,
    PreviewInvoiceComponent,
    StatementComponent,
    MaterialMarketWatchComponent,
    DetailedQuotaComponent,
    SlickMarketWatchComponent,
    QuotaBidsAsksComponent,
    QuotaTradeComponent,
    MarginCalculatorComponent,
    TradesHistoryComponent,
    TradesOrderHistoryComponent,
    SelectedOrderTradeComponent,
    OrderHistoryComponent,
    TwfaComponent,
    NewLoginComponent,
    CheckArrayPipe,
    OrdinalPipe,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    SelectCompanyModalComponent,
    CreateUserComponent,
    VerifyEmailComponent,
    PasswordValidationSectionComponent,
    SettingsComponent,
    NotFullMarketComponent,
    TradingViewChartComponent,
    AnimatedTextComponent,
    MillionPipe,
    TradingViewChartComponent,
    AnimatedTextComponent,
    InvoicesModalComponent,
    TechnicalReportsComponent,
    InfoModalComponent,
    IPOComponent,
    IpoSelectedSymbolComponent,
    IpoSelectedSymbolTimlinePdfComponent,
    TimeFormatPipe,
    TestComponent,
    FavoriteMenuComponent,
    MutualFundComponent,
    FundAccOrderModalComponent,
    SelectedSymbolChartsComponent,
    SelectedSymbolDetailsPdfsComponent,
    IpoAccOrderModalComponent,
    IpoAccOrderModalComponent,
    ReportingComponent,
    GenericReportComponent,
    ReportsComponent,
    FundmentalReportComponent
  ],
  imports: [
    DxReportViewerModule,
    SignalRModule.forRoot(createConfig),
    NgCircleProgressModule.forRoot(),
    BrowserModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CommonModule,
    RecaptchaV3Module,
    MatFormFieldModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatListModule,
    GridsterModule,
    DynamicModule,
    MatMenuModule,
    MatCardModule,
    NgApexchartsModule,
    MatTabsModule,
    NgxDatatableModule,
    NgxMarqueeModule,
    MatRadioModule,
    MatDatepickerModule,
    CarouselModule,
    MatNativeDateModule,
    KtdGridModule,
    MatTableModule,
    DragDropModule,
    MatProgressBarModule,
    SlickCarouselModule,
    ExportAsModule,
    NgxPrintModule,
    NgSelectModule,
    DataTablesModule,
    MatTabsModule,
    MatSortModule,
    NgxPrinterModule.forRoot({ printOpenWindow: true }),
    AngularSlickgridModule.forRoot(),
    ContextMenuModule.forRoot(),
    NgbAccordionModule,
    MatMomentDateModule,
    MatTooltipModule,
    NgbTooltipModule,
    MatStepperModule,
    MatTabsModule,
    NgxSliderModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgbModule,
    UserIdleModule.forRoot({}),
    NgxLoadingModule.forRoot({}),
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: "primary", // set defaults here
    }),
    ToastrModule.forRoot(),
    SharedModule,
  ],
  exports: [MatButtonModule, MatTableModule, NgbAccordionModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    SignalRService,
    MatDatepickerModule,
    DatePipe,
    UpdateFlashDirective,
    ConfigService,
    MillionPipe,
    DecimalPipe,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true,
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestHeaderInterceptor,
      multi: true,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: TokenInterceptorInterceptor,
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
